"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeStyles = void 0;
// Merges CSS styles like `classNames` merges CSS classes
function mergeStyles(...styles) {
    let result = {};
    for (const style of styles) {
        if (style) {
            result = { ...result, ...style };
        }
    }
    return Object.keys(result).length ? result : undefined;
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=merge-styles.js.map